module.exports = __webpack_public_path__ + "img/colour_wheel_300.96b5dd03.jpg";